import React from "react";
import {
  chiefPatron,
  patrons,
  coPatrons,
  conferenceChair,
} from "../data/mockData";

const Dignitaries = () => {
  return (
    <div className="bg-white min-h-screen">
      {/* Page Header */}
      <div className="bg-blue-950 py-16 text-center">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-white mb-4 tracking-wider">
          DIGNITARIES
        </h1>
        <div className="w-32 sm:w-48 h-1 bg-blue-600 mx-auto"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        {/* Chief Patron Section */}
        <section className="mb-20">
          <div className="bg-gradient-to-r from-primary-300 to-blue-200 p-6 sm:p-8 mb-12 text-center rounded-lg border-l-4 border-primary-600">
            <h2 className="text-3xl sm:text-4xl font-bold text-blue-950">
              CHIEF PATRON
            </h2>
          </div>

          <div className="flex justify-center">
            <div className="w-full max-w-md bg-white rounded-xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 border-t-4 border-primary-600">
              <a
                href={chiefPatron.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="block h-96 overflow-hidden"
              >
                <img
                  src={chiefPatron.image}
                  alt={chiefPatron.name}
                  className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                />
              </a>
              <div className="p-6 text-center bg-gradient-to-br from-blue-100 to-blue-50">
                <h3 className="text-2xl font-bold text-primary-900 mb-2">
                  <a
                    href={chiefPatron.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline hover:text-blue-700 transition-colors"
                  >
                    {chiefPatron.name}
                  </a>
                </h3>
                <p className="text-lg text-primary-700 font-semibold">
                  {chiefPatron.designation}
                </p>
                <p className="text-gray-600 mt-2">{chiefPatron.organization}</p>
              </div>
            </div>
          </div>
        </section>

        {/* Patron Section */}
        <section className="mb-20">
          <div className="bg-gradient-to-r from-primary-300 to-blue-200 p-6 sm:p-8 mb-12 text-center rounded-lg border-l-4 border-primary-600">
            <h2 className="text-3xl sm:text-4xl font-bold text-blue-950">
              PATRONS
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {patrons.map((patron) => (
              <div
                key={patron.id}
                className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 border-t-4 border-primary-500"
              >
                {/* Clickable Image */}
                <a
                  href={patron.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block h-72 overflow-hidden"
                >
                  <img
                    src={patron.image}
                    alt={patron.name}
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                  />
                </a>

                <div className="p-4 text-center bg-gradient-to-br from-blue-100 to-blue-50">
                  {/* Clickable Name */}
                  <h3 className="text-lg font-bold text-primary-900 mb-1">
                    <a
                      href={patron.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:underline hover:text-blue-700 transition-all duration-300"
                    >
                      {patron.name}
                    </a>
                  </h3>

                  <p className="text-md text-primary-600 font-semibold">
                    {patron.designation}
                  </p>
                  <p className="text-md text-gray-600 mt-1">
                    {patron.organization}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Conference Chair Section */}
        <section className="mb-20">
          <div className="bg-gradient-to-r from-primary-300 to-blue-200 p-6 sm:p-8 mb-12 text-center rounded-lg border-l-4 border-primary-600">
            <h2 className="text-3xl sm:text-4xl font-bold text-blue-950">
              CONFERENCE CHAIR
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {conferenceChair.map((conferenceChair) => (
              <div
                key={conferenceChair.id}
                className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 border-t-4 border-primary-500"
              >
                {/* Clickable Image */}
                <a
                  href={conferenceChair.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block h-72 overflow-hidden"
                >
                  <img
                    src={conferenceChair.image}
                    alt={conferenceChair.name}
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                  />
                </a>

                <div className="p-4 text-center bg-gradient-to-br from-blue-100 to-blue-50">
                  {/* Clickable Name */}
                  <h3 className="text-lg font-bold text-primary-900 mb-1">
                    <a
                      href={conferenceChair.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:underline hover:text-blue-700 transition-all duration-300"
                    >
                      {conferenceChair.name}
                    </a>
                  </h3>

                  <p className="text-md text-primary-600 font-semibold">
                    {conferenceChair.designation}
                  </p>
                  <p className="text-md text-gray-600 mt-1">
                    {conferenceChair.organization}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Co-Patrons Section */}
        <section>
          <div className="bg-gradient-to-r from-primary-300 to-blue-200 p-6 sm:p-8 mb-12 text-center rounded-lg border-l-4 border-primary-600">
            <h2 className="text-3xl sm:text-4xl font-bold text-blue-950">
              CO-PATRONS
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {coPatrons.map((coPatron) => (
              <div
                key={coPatron.id}
                className="bg-gradient-to-br from-blue-100 to-blue-50 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 border-t-4 border-blue-400"
              >
                {/* Clickable Image */}
                <a
                  href={coPatron.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block h-72 overflow-hidden"
                >
                  <img
                    src={coPatron.image}
                    alt={coPatron.name}
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                  />
                </a>

                <div className="p-4 text-center bg-gradient-to-br from-blue-100 to-blue-50">
                  {/* Clickable Name */}
                  <h3 className="text-lg font-bold text-primary-900 mb-1">
                    <a
                      href={coPatron.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:underline hover:text-blue-700 transition-all duration-300"
                    >
                      {coPatron.name}
                    </a>
                  </h3>

                  <p className="text-md text-primary-600 font-semibold">
                    {coPatron.designation}
                  </p>
                  <p className="text-md text-gray-600 mt-1">
                    {coPatron.organization}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Dignitaries;
